window.addEventListener("DOMContentLoaded", () => {
    let customer_gallery = document.querySelector('.customer-gallery.large-gallery')
    if(customer_gallery){
        console.log(customer_gallery)
        let gallery_length = parseInt(customer_gallery.dataset.galleryLength);
        let initial_number = parseInt(customer_gallery.dataset.initialNumber);
        let items = customer_gallery.querySelectorAll('.item')
        let viewall = customer_gallery.querySelector('.view-all')

        if(initial_number <= gallery_length){
            for(let i = 0; i < initial_number; i++){
                items[i].classList.remove('hidden')
            }
            viewall.classList.remove('hidden')
        }
        viewall.addEventListener('click', ()=>{
            items.forEach(item =>{
                item.classList.remove('hidden')
            })
            viewall.classList.add('hidden')
        })
    }
});
